import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-qr-label',
    templateUrl: './qr-label.component.html',
    styleUrls: ['./qr-label.component.scss'],
})
export class QrLabelComponent implements OnInit {
    @Input() qrData: string;
    constructor() {}

    ngOnInit(): void {}
}
